import React, { useState } from 'react';

import { PrimaryButton } from '@magoosh/lib/button';
import Tabs from '@magoosh/lib/tabs';
import AudioOutputConfig from '@magoosh/organisms/audio/audio_output_config';
import MicrophoneConfig from '@magoosh/organisms/audio/microphone_config';

import CompatibilityModeToggle from './compatibility_mode_toggle';
import { Settings } from './index';

interface Props {
  onClose: () => void;
  onSave?: (payload: Settings) => void;
  compatibilityMode?: boolean;
}

export default (props: Props) => {
  const [compatibilityMode, setCompatibilityMode] = useState(props.compatibilityMode);

  const handleSave = () => {
    props.onSave?.({
      compatibilityMode
    });
    props.onClose();
  };

  return (
    <div className="d-flex flex-column gap-m u-margin-B-m">
      <Tabs defaultTab="audioPlayback">
        <Tabs.Tab tab="audioPlayback">Audio Playback</Tabs.Tab>
        <Tabs.Tab tab="microphone">Microphone</Tabs.Tab>

        <Tabs.Panel tab="audioPlayback">
          <div className="d-flex flex-column gap-s">
            <h4 className="u-margin-A-n">
              <strong>Audio Playback</strong>
            </h4>

            <AudioOutputConfig />
          </div>
        </Tabs.Panel>

        <Tabs.Panel tab="microphone">
          <div className="d-flex flex-column gap-s">
            <h4 className="u-margin-A-n">
              <strong>Microphone Input</strong>
            </h4>

            <MicrophoneConfig />
          </div>
        </Tabs.Panel>
      </Tabs>

      <hr className="u-margin-A-n" />

      <div className="d-flex flex-column gap-s">
        <h4 className="u-margin-A-n">
          <strong>Compatibility Mode</strong>
        </h4>

        <div>
          Compatibility mode can solve various browser issues with hearing/recording audio. However, enabling it makes for a different experience than the real test. On test day, audio will only be played once, and all playback/recording progresses automatically.
        </div>

        <CompatibilityModeToggle
          enabled={compatibilityMode}
          onToggle={() => setCompatibilityMode(!compatibilityMode)}
        />
      </div>

      <PrimaryButton type="submit" onClick={handleSave}>
        Save And Restart Audio/Video
      </PrimaryButton>
    </div>
  );
};
